import {
    DestinationEvent,
    transformDestinationEvent,
} from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import { Stack, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { useEnvContext } from '../../../../context';
import { EventCardContainer } from '../../components/EventCardContainer/EventCardContainer';
import styles from './EventSection.module.scss';

export interface EventSectionProps {
    nearbyEvents: Array<DestinationEvent>;
    pointOfInterestName: string;
}
const DEFAULT_CURRENCY_FORMAT = '¤#,##0.00';

export const EventSection: React.FunctionComponent<EventSectionProps> = (
    props,
) => {
    const { env, user } = useEnvContext();
    // TODO: Add Statsig Feature gate here
    const SHOULD_SHOW_EVENTS = props?.nearbyEvents?.length > 0;

    if (!SHOULD_SHOW_EVENTS) return null;

    return (
        <div className={styles.eventSection}>
            <Stack space="spacing-xs">
                <Typography
                    className={styles.textContainer}
                    align="left"
                    as="h2"
                    color="neutral-800"
                    variant="heading-md"
                >
                    {gettext('Events and activities near %(pointOfInterest)s', {
                        pointOfInterest: props.pointOfInterestName,
                    })}
                </Typography>
                <Typography
                    className={styles.textContainer}
                    align="left"
                    as="p"
                    color="neutral-800"
                    variant="heading-xs"
                >
                    {gettext('Explore our most popular events nearby.')}
                </Typography>
            </Stack>
            <div className={styles.eventsContainer}>
                {props.nearbyEvents?.map((eventData, idx) => (
                    <EventCardContainer
                        isAuthenticated={user?.isAuthenticated ?? false}
                        eventData={transformDestinationEvent(eventData)}
                        key={idx}
                        currencyFormat={
                            env?.currencyFormat ?? DEFAULT_CURRENCY_FORMAT
                        }
                    />
                ))}
            </div>
        </div>
    );
};
